import { RootState } from 'store/root-reducer';

export const jobKeptQuerySelector = (rootState: RootState) => rootState.keptQuery.jobList;
